import { render, staticRenderFns } from "./MonitoringFeatureDetails.vue?vue&type=template&id=59b41988"
import script from "./MonitoringFeatureDetails.vue?vue&type=script&lang=js"
export * from "./MonitoringFeatureDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports